import React, { useEffect, useState } from "react";

const DualListBox = ({ items, selected, changeOption }) => {
  const [availableItems, setAvailableItems] = useState(items);
  const [selectedItems, setSelectedItems] = useState([]);
  const [searchAvailable, setSearchAvailable] = useState("");
  const [searchSelected, setSearchSelected] = useState("");
  const [selectedIndices, setSelectedIndices] = useState([]);
  const [selectedRightIndices, setSelectedRightIndices] = useState([]);

  useEffect(() => {
    if (items && items.length > 0) {
      const initialAvailableItems = items.filter((item) => !item.selected);
      const initialSelectedItems = selected;
      setAvailableItems(initialAvailableItems);
      setSelectedItems(initialSelectedItems);
      console.log(initialAvailableItems);
    }
  }, [items, selected]);

  useEffect(() => {
    changeOption(selectedItems);
  }, [selectedItems, changeOption]);

  const handleMoveRight = () => {
    const newSelectedItems = [
      ...selectedItems,
      ...availableItems.filter((item, index) =>
        selectedIndices.includes(index)
      ),
    ];
    const newAvailableItems = availableItems.filter(
      (item, index) => !selectedIndices.includes(index)
    );
    setAvailableItems(newAvailableItems);
    setSelectedItems(
      newSelectedItems.map((item) => ({ ...item, selected: false }))
    );
    setSelectedIndices([]);
  };

  const handleMoveAllRight = () => {
    const newSelectedItems = [...selectedItems, ...availableItems];
    setAvailableItems([]);
    setSelectedItems(newSelectedItems);
  };

  const handleMoveLeft = () => {
    const newAvailableItems = [
      ...availableItems,
      ...selectedItems.filter((item, index) =>
        selectedRightIndices.includes(index)
      ),
    ];
    const newSelectedItems = selectedItems.filter(
      (item, index) => !selectedRightIndices.includes(index)
    );
    setAvailableItems(
      newAvailableItems.map((item) => ({ ...item, selected: false }))
    );
    setSelectedItems(newSelectedItems);
    setSelectedRightIndices([]);
  };

  const handleMoveAllLeft = () => {
    const newAvailableItems = [...availableItems, ...selectedItems];
    setAvailableItems(newAvailableItems);
    setSelectedItems([]);
  };

  const handleToggleSelect = (e, list, setIndices) => {
    console.log(e.target.value);
    console.log(e.target);
    const selectedOptions = Array.from(e.target.selectedOptions, (option) =>
      parseInt(option.value)
    );
    setIndices(selectedOptions);
  };

  const handleSearch = (e, setSearch) => {
    setSearch(e.target.value);
  };

  const filterItems = (items, search) => {
    return items.filter((item) =>
      item.name.toLowerCase().includes(search.toLowerCase())
    );
  };

  const moveItem = (direction) => {
    if (selectedRightIndices.length !== 1) return;
    const index = selectedRightIndices[0];
    const newSelectedItems = [...selectedItems];
    const [movedItem] = newSelectedItems.splice(index, 1);
    newSelectedItems.splice(index + direction, 0, movedItem);
    setSelectedItems(newSelectedItems);
    setSelectedRightIndices([index + direction]);
  };

  const handleMoveToFirst = () => {
    if (selectedRightIndices.length !== 1) return;
    const index = selectedRightIndices[0];
    const movedItem = selectedItems[index];
    const newSelectedItems = selectedItems.filter((item, idx) => idx !== index);
    setSelectedItems([movedItem, ...newSelectedItems]);
    setSelectedRightIndices([0]);
  };

  const handleMoveToLast = () => {
    if (selectedRightIndices.length !== 1) return;
    const index = selectedRightIndices[0];
    const movedItem = selectedItems[index];
    const newSelectedItems = selectedItems.filter((item, idx) => idx !== index);
    setSelectedItems([...newSelectedItems, movedItem]);
    setSelectedRightIndices([selectedItems.length - 1]);
  };

  return (
    <div className="d-flex">
      {/* list box */}
      <div className="w-50">
        {/* search item */}
        <input
          type="text"
          className="form-control mb-2"
          placeholder="Search available..."
          value={searchAvailable}
          onChange={(e) => handleSearch(e, setSearchAvailable)}
        />
        {/* list */}
        <select
          multiple
          className="form-control"
          size={10}
          onChange={(e) =>
            handleToggleSelect(e, availableItems, setSelectedIndices)
          }
        >
          {filterItems(availableItems, searchAvailable)?.map((item, index) => (
            <option key={item.id} value={index}>
              {/* here i'm | change index to item.id */}
              {item.name}
            </option>
          ))}
        </select>
      </div>

      {/* add / remove buttons */}
      <div className="d-flex flex-column justify-content-center align-items-center mx-3 rdl-icons-fa6   ">
        <div className="rdl-actions">
          {/* add all / add one button */}
          <div className="rdl-actions-to-selected">
            {/* add all */}
            <button
              aria-label="Move all to selected"
              className="rdl-btn rdl-move rdl-move-all-to-selected"
              title="Move all to selected"
              type="button"
              onClick={handleMoveAllRight}
            >
              <span className="rdl-icon rdl-icon-move-all-to-selected"></span>
            </button>
            {/* add one */}
            <button
              aria-label="Move to selected"
              className="rdl-btn rdl-move rdl-move-to-selected"
              title="Move to selected"
              type="button"
              onClick={handleMoveRight}
            >
              <span className="rdl-icon rdl-icon-move-to-selected"></span>
            </button>
          </div>

          {/* remove all / remove one button */}
          <div className="rdl-actions-to-available">
            {/* remove one */}
            <button
              aria-label="Move to available"
              className="rdl-btn rdl-move rdl-move-to-available"
              title="Move to available"
              type="button"
              onClick={handleMoveLeft}
            >
              <span className="rdl-icon rdl-icon-move-to-available"></span>
            </button>
            {/* remove all */}
            <button
              aria-label="Move all to available"
              className="rdl-btn rdl-move rdl-move-all-to-available"
              title="Move all to available"
              type="button"
              onClick={handleMoveAllLeft}
            >
              <span className="rdl-icon rdl-icon-move-all-to-available"></span>
            </button>
          </div>
        </div>
      </div>

      {/* selected items box */}
      <div className="w-50">
        {/* search selected item */}
        <input
          type="text"
          className="form-control mb-2"
          placeholder="Search selected..."
          value={searchSelected}
          onChange={(e) => handleSearch(e, setSearchSelected)}
        />
        {/* selected item list */}
        <select
          multiple
          className="form-control"
          size={10}
          onChange={(e) =>
            handleToggleSelect(e, selectedItems, setSelectedRightIndices)
          }
        >
          {filterItems(selectedItems, searchSelected)?.map((item, index) => (
            <option key={item.id} value={index}>
              {item.name}
            </option>
          ))}
        </select>
      </div>

      {/* up / down direction buttons */}
      <div className="d-flex flex-column justify-content-center align-items-center mx-3 rdl-icons-fa6">
        <div className="rdl-actions">
          {/* to top */}
          <button
            aria-label="Rearrange to top"
            className="rdl-btn rdl-move rdl-move-top"
            title="Rearrange to top"
            type="button"
            onClick={handleMoveToFirst}
          >
            <span className="rdl-icon rdl-icon-move-top"></span>
          </button>

          {/* up */}
          <button
            aria-label="Rearrange up"
            className="rdl-btn rdl-move rdl-move-up"
            title="Rearrange up"
            type="button"
            onClick={() => moveItem(-1)}
            disabled={
              selectedRightIndices.length !== 1 || selectedRightIndices[0] <= 0
            }
          >
            <span className="rdl-icon rdl-icon-move-up"></span>
          </button>

          {/* down */}
          <button
            aria-label="Rearrange down"
            className="rdl-btn rdl-move rdl-move-down"
            title="Rearrange down"
            type="button"
            onClick={() => moveItem(1)}
            disabled={
              selectedRightIndices.length !== 1 ||
              selectedRightIndices[0] === selectedItems.length - 1
            }
          >
            <span className="rdl-icon rdl-icon-move-down"></span>
          </button>

          {/* to bottom */}
          <button
            aria-label="Rearrange to bottom"
            className="rdl-btn rdl-move rdl-move-bottom"
            title="Rearrange to bottom"
            type="button"
            onClick={handleMoveToLast}
          >
            <span className="rdl-icon rdl-icon-move-bottom"></span>
          </button>
        </div>
      </div>
    </div>
  );
};

export default DualListBox;
